module.exports = __webpack_public_path__ + "img/GreenMail.df0e632d.svg";